// utils/GlobalLogger.ts

import { HandleGlobalLoggingApi } from "../app/modules/core/_request";
import { envConfig } from "./config";

export type LogLevel = "INFO" | "WARNING" | "ERROR";

export interface GlobalLogPayload {
    level: LogLevel;
    message: string;
    module: string;
    error?: unknown;
    timestamp: string;
}

export const GlobalLogger = async (
    level: LogLevel,
    message: string,
    error: unknown = null,
    module: string = "Unknown"
): Promise<void> => {
    const env = envConfig.APP_SERVER?.toLowerCase();

    const logData: GlobalLogPayload = {
        level,
        message,
        module,
        error,
        timestamp: new Date().toISOString(),
    };

    try {
        if (env === "local") {
            console.error(`[${level}] [${module}] ${message}`, error);
            return;
        }

        await HandleGlobalLoggingApi(logData);
    } catch (loggingError) {
        console.error("Global Logging Failed:", loggingError);
    }
};

export const LogError = (
    message: string,
    error?: unknown,
    module: string = "Unknown"
): Promise<void> =>
    GlobalLogger("ERROR", message, error, module);

export const LogWarning = (
    message: string,
    module: string = "Unknown"
): Promise<void> =>
    GlobalLogger("WARNING", message, null, module);

export const LogInfo = (
    message: string,
    module: string = "Unknown"
): Promise<void> =>
    GlobalLogger("INFO", message, null, module);